import { DocCard, Switch } from 'components';
import style from './index.module.scss';
import { useOutletContext } from 'react-router-dom';
import { Form, FormInstance } from 'antd';
import { useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { WORKER_STATUS } from 'api';

export type TDocumentations = {
  icon: string;
  text: string;
  file: 'cuit' | 'enrollment' | 'insurance' | 'goodConduct';
  rejected?: boolean;
}[];

export const Step4CompalteProfile = () => {
  const terms = useSelector(
    (state: any) => state.processComplate?.values?.[3].terms,
  );
  const fieldsWithError = useSelector(
    (state: any) => state.profile?.data?.fieldsWithError,
  );
  const userStatus = useSelector((state: any) => state.profile?.data?.state);
  const files = useSelector((state: any) => state.profile?.data?.files);
  const form = useOutletContext() as FormInstance;
  const filesWatched = Form.useWatch(['files'], form);
  const documentations: TDocumentations = [
    {
      icon: '../../../assets/icon/card.svg',
      text: 'DNI',
      file: 'cuit',
      rejected:
        fieldsWithError?.includes('cuit') &&
        !filesWatched?.find(({ file }: any) => file === 'cuit'),
    },
    {
      icon: '../../../assets/icon/alquilar.svg',
      text: 'Poder presentar Título de curso/estudios finalizado',
      file: 'enrollment',
      rejected:
        fieldsWithError?.includes('enrollment') &&
        !filesWatched?.find(({ file }: any) => file === 'enrollment'),
    },
    {
      icon: '../../../assets/icon/segurity.svg',
      text: 'Constancia de Seguro',
      file: 'insurance',
      rejected:
        fieldsWithError?.includes('insurance') &&
        !filesWatched?.find(({ file }: any) => file === 'insurance'),
    },
    {
      icon: '../../../assets/icon/proteger.svg',
      text: 'Documentos que considere de relevancia',
      file: 'goodConduct',
      rejected:
        fieldsWithError?.includes('goodConduct') &&
        !filesWatched?.find(({ file }: any) => file === 'goodConduct'),
    },
  ];

  useEffect(() => {
    form.setFieldValue('files', []);
  }, [form]);

  const onSetFiles = useCallback(
    (newFileType: TDocumentations[number]['file'], blob: Blob) => {
      const oldFiles = (form.getFieldValue('files') as []) || [];
      let newFiles: { file: TDocumentations[0]['file']; blob: Blob }[] = [];
      if (oldFiles.some(({ file }) => file === newFileType)) {
        newFiles = [
          ...oldFiles.filter(({ file }) => file !== newFileType),
          { file: newFileType, blob },
        ];
      } else {
        newFiles = [...oldFiles, { file: newFileType, blob }];
      }
      form.setFieldValue('files', newFiles);
    },
    [form],
  );

  const seeTerms = () => {
    window.location.href = 'https://aqnllamo.com/terms-of-use-for-workers/';
  };

  const rejectedFiles = documentations.filter((doc) => doc.rejected);

  return (
    <div className={style.content}>
      <div className={style.cards}>
        {documentations.map((doc) => (
          <DocCard
            rejected={doc.rejected}
            uploaded={files?.some(({ type }: any) => type === doc.file)}
            disabled={WORKER_STATUS.waitingRevision === userStatus}
            onBlob={(blob) => onSetFiles(doc.file, blob)}
            icon={doc.icon}
            text={doc.text}
          />
        ))}
      </div>
      {!!rejectedFiles.length && (
        <div>
          <p className={style.rejected}>Archivos rechazados</p>
          {rejectedFiles.map((doc) => (
            <div>{doc.text}</div>
          ))}
        </div>
      )}
      <div>
        <Switch
          disabled={WORKER_STATUS.waitingRevision === userStatus}
          defaultChecked={terms || WORKER_STATUS.needInformation !== userStatus}
          onChange={(checked) =>
            form.setFieldValue('terms', checked ? true : null)
          }
          label={
            <p className={style.terms}>
              He leído y acepto los
              <p onClick={seeTerms}>Términos y Condiciones</p>
            </p>
          }
        />
        <Form
          disabled={WORKER_STATUS.waitingRevision === userStatus}
          layout={'vertical'}
          form={form}
        >
          <Form.Item hidden name="files" />
          <Form.Item hidden name="terms" rules={[{ required: true }]} />
        </Form>
      </div>
    </div>
  );
};
